@if(!isSharing()) {
  <div class="CloseButtonContainer">
    <button (click)="closeButtonClicked()" mat-icon-button class="CloseMenuButton"><mat-icon>close</mat-icon></button>
  </div>
}
<div #CheckoutContainer class="Grid Gap--larger Content" [class.RetailOnly]="isRetailOnlyMode()" [class.IsSharing]="isSharing()">
 @if (isRetailOnlyMode() && !isSharing()) {
    <div class="ShareInstructionsContainer Flexbox Flexbox--column Align--center">
      <div class="PrintInstructions">
        <p>
          @if (!shouldShowConsumerSiteShare()) {
            {{ shareMessage() }}
          } @else if (retailerName()) {
            To order your customized ring, please visit <a (click)="retailerLinkClicked($event)" href="#">{{ retailerName() }}</a> — or simply share the link below with them directly.
          } @else {
            To order your customized ring, <a href="https://www.benchmarkrings.com/find-a-retailer" target="_blank">locate</a> your nearest Benchmark retailer — or simply share the link below with them directly.
          }
        </p>
      </div>
    </div>
  }

    @if (!isSharing()) {
      @if(!isRetailOnlyMode()) {
        <mat-form-field appearance="outline" class="LinePO">
          <mat-label>PO #</mat-label>
          <input matInput maxlength="20" [disabled]="isSharing()" [(ngModel)]="poValue" (change)="poChange()">
        </mat-form-field>
      }
    } @else if (poValue) {
      <div class="AttributeName">PO #</div>
      <div class="AttributeValue">{{ poValue }}</div>
    }

  <!-- @if(isRetailOnlyMode()) {
    <table class="AttributeTable">
      <tr>
        <td>Retail Price</td>
        <td>{{ retailPrice() | currency: 'USD' : 'symbol' : '1.0-0' }} as of {{ priceDate() }}</td>
      </tr>
    </table>
  } -->
    <!-- <div class="Flexbox">
      @if (!isSharing() && !isRetailOnlyMode()) {
        <button mat-flat-button color="primary" class="ShareButton" #ShareButton (click)="shareClicked()">
          Share Ring

        </button>
      }
    </div> -->

    @if (!isSharing()) {
      <div class="Flexbox Flexbox--column Gap--smaller">
        <div class="Flexbox Align--center Gap--smaller">
          <mat-form-field appearance="outline" class="ShareLinkTextArea">
            <mat-label>Share Ring Link</mat-label>
            <input #shareLinkTextArea matInput (keypress)="shareURLFieldKeyDown($event)" [value]="shareLink()">
          </mat-form-field>
          <button mat-icon-button class="NavButton ShareButton ThemeColorAccent" #ShareButton (click)="copyShareClicked()"><mat-icon>assignment</mat-icon></button>
        </div>
        @if (shouldShowCopyConfirmation()) {
          <span class="CopyConfirmation">Share url copied!</span>
        }
      </div>
    }

  <h3 class="ItemDetailTitle">Ring Detail</h3>
  <div class="Flexbox Flexbox--column Align--flex-start">
    <div class="AttributeName">Item #</div>
    <div class="AttributeValue">{{ actualSKUToShow() ?? itemNumber() }}</div>

    @for (attribute of attributeKeys(); track $index) {

        <div class="AttributeName">{{ attribute }}</div>
        <div class="AttributeValue" [ngStyle]="getStyle(attribute)">
            @if (attribute === 'Engraving' && !getAttributeValue(attribute)) {
              No Engraving
            } @else {
              {{ getAttributeValue(attribute) }}
            }
        </div>

      @if (isSharing() && attribute === 'Engraving' && getAttributeValue(attribute) && selectedAttributes().engravingType) {

        <div class="AttributeName">Engraving Type</div>
        <div class="AttributeValue">{{ selectedAttributes().engravingType?.displayName }}</div>

      }
    }
    @if (!!selectedAttributes().gemstoneType) {
      <div class="AttributeName">Gemstone Total Weight</div>
      <div class="AttributeValue">{{ (selectedAttributes().gemstoneSize?.value ?? 0) * (stoneCount() ?? 0) }}ctw</div>
    }
  </div>

    @if (isRetailOnlyMode() && isSharing()) {
    <div class="Flexbox Align--center Gap--normal">
      <div class="PrintFix Flexbox Flexbox--column Align--flex-start Justify--center">
        <span>Retail Estimate</span>
      </div>
      <div class="Flexbox">
        <app-price [price]="retailPrice() ?? undefined" [type]="'rounded-only'"></app-price>
      </div>
    </div>
    }
</div>
